import type { Child } from "./api/children.queries"

// Raw color reads clearer than a semantic token here.
export function sexTint(sex: Child["sex"]): string {
  return sex === "girl" ? "text-pink-300" : "text-sky-300"
}
